import { computed, makeObservable } from "mobx";
export class PlayerPageState {
    constructor(options) {
        this.parser = options.parser;
        this.playerId = options.playerId;
        this.playerImage = options.playerImage;
        this.marketboardBlock = options.marketboardBlock;
        this.dict = options.dict;
        this.playerBiometricData = options.playerBiometricData;
        this.tabSwitcherController = options.tabSwitcherController;
        this.productConfig = options.productConfig;
        this.isPlayerImageDisabled = options.isPlayerImageDisabled;
        this.trackEvent = options.trackEvent;
        this.consumerVersion = options.consumerVersion;
        makeObservable(this, {
            header: computed
        });
    }
    activate() {
        this.parser.activate();
        this.marketboardBlock.activateDataProvider();
        !this.playerBiometricData && void this.parser.loadBiometricData(this.playerId.toString());
    }
    deactivate() {
        this.parser.deactivate();
        this.marketboardBlock.deactivate();
        // This line uses null intentionally
        // eslint-disable-next-line no-null/no-null
        this.playerBiometricData = null;
    }
    setParams(params) {
        this.parser.setParams(params);
        this.playerId = params.playerId;
    }
    get marketboard() {
        return this.marketboardBlock.component;
    }
    get header() {
        return {
            playerId: this.playerId,
            playerImage: this.playerImage,
            player: this.parser.playerBiometricData[this.parser.playerBiometricData.length - 1],
            productConfig: this.productConfig,
            isPlayerImageDisabled: this.isPlayerImageDisabled,
            trackEvent: this.trackEvent,
            consumerVersion: this.consumerVersion
        };
    }
}
//# sourceMappingURL=PlayerPageState.js.map